export const environment = {
    production: false,
    // apiUrl: 'http://localhost:8080',
    apiUrl: 'https://pos-gateway.siamese-sandbox.com',
};
